import React, { useRef } from "react";
import i18n from "locale/i18n";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "routes";

import {
  isTrialOrInitialTrialingSelector,
  isMobile,
  setUserIsPendingSelector,
  setUserErrorSelector
} from "@kubera/common";

import ConfirmationDialog from "components/dialog/ConfirmationDialog";
import GenericMessageDialog from "components/dialog/GenericMessageDialog";
import { GAWrapperEvent } from "utilities/GAWrapper";
import { ANALYTICS } from "analytics";

const IFrame = styled.iframe`
  display: block;
  width: 100%;
  height: 100vh;
  border: none;
`;

const isMobileDevice = isMobile();
const BillboardComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isIframeLoaded = useRef(false);

  const isTrialOrInitialTrialing = useSelector(isTrialOrInitialTrialingSelector);
  const isUserPending = useSelector(setUserIsPendingSelector);
  const isUserError = useSelector(setUserErrorSelector);

  const url = process.env.REACT_APP_API_BASE_URL + "/auth/utility/billboard";

  const handleClose = () => {
    window.close();

    setTimeout(() => {
      navigate(routes.NET_WORTH);
    }, 1000);
  };

  const handleDialogPositiveButtonClick = () => {
    if (location.state || (document.referrer && new URL(document.referrer).origin === window.location.origin)) {
      isMobileDevice ? navigate(-1) : handleClose();
    } else {
      navigate(routes.NET_WORTH); // or homepage
    }
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleIframeLoad = () => {
    console.log("iframe loaded");
    isIframeLoaded.current = true;

    GAWrapperEvent({
      category: ANALYTICS.CATEGORY.USER,
      action: ANALYTICS.ACTION.BILLBOARD
    });
  };

  if (isTrialOrInitialTrialing) {
    return (
      <ConfirmationDialog
        title={i18n.t("billboard")}
        description={i18n.t("billboard.blocked.desc")}
        positiveButtonTitle={i18n.t("ok")}
        handlePositiveButtonClick={handleDialogPositiveButtonClick}
      />
    );
  }

  if (isIframeLoaded.current || (isUserPending === false && isUserError === false)) {
    return <IFrame src={url} onLoad={handleIframeLoad} />;
  }

  if (isUserPending) {
    return null;
  }

  return (
    <GenericMessageDialog
      title={i18n.t("genericExceptionTitle")}
      onOverlayDismissClick={handleRefresh}
      onNegativeButtonClick={handleDialogPositiveButtonClick}
      positiveButtonTitle={i18n.t("refresh")}
      negativeButtonTitle={i18n.t("close")}
    />
  );
};

export default BillboardComponent;
